module.exports = __webpack_public_path__ + "static/media/tt.9b4ef995.svg";